import { format, formatDistanceToNowStrict, parseISO } from 'date-fns';

export function formatDate(iso: string | null | undefined, fmt = 'MMM d, yyyy'): string {
  if (!iso) return '—';
  try {
    return format(parseISO(iso), fmt);
  } catch {
    return iso;
  }
}

export function formatDateTime(iso: string | null | undefined): string {
  return formatDate(iso, 'MMM d, yyyy HH:mm');
}

export function timeAgo(iso: string | null | undefined): string {
  if (!iso) return '—';
  try {
    return `${formatDistanceToNowStrict(parseISO(iso))} ago`;
  } catch {
    return iso;
  }
}

export function formatHourRange(min: number | null, max: number | null): string {
  if (min == null && max == null) return '—';
  if (min != null && max != null) {
    if (Math.abs(min - max) < 0.05) return `${trim(min)} h`;
    return `${trim(min)}–${trim(max)} h`;
  }
  return `${trim((min ?? max) as number)} h`;
}

export function formatHours(value: number | null | undefined): string {
  if (value == null) return '—';
  return `${trim(value)} h`;
}

export function formatPercent(value: number | null | undefined): string {
  if (value == null || Number.isNaN(value)) return '—';
  return `${Math.round(value * 100)}%`;
}

export function trim(n: number): string {
  if (Number.isInteger(n)) return String(n);
  // Up to 2 decimal places with trailing zeros stripped, so 1 → "1", 1.5 → "1.5",
  // 1.25 → "1.25". Time entries in Jira are commonly logged in 0.25h or 0.05h chunks,
  // so dropping to 1 decimal lost meaningful precision on the displayed totals.
  return n.toFixed(2).replace(/\.?0+$/, '');
}

export function formatMoney(cents: number, currency = 'USD'): string {
  try {
    return new Intl.NumberFormat(undefined, {
      style: 'currency',
      currency,
      minimumFractionDigits: cents % 100 === 0 ? 0 : 2,
    }).format(cents / 100);
  } catch {
    return `${(cents / 100).toFixed(2)} ${currency}`;
  }
}
